import React, { useState, useRef, useContext, useEffect } from "react";
//@ts-ignore
import classnames from "classnames";
import AuthContext from "../../../../../contexts/Auth";
import SimpleHeader from "../../../../../components/Headers/SimpleHeader";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  Button,
  Spinner,
  CustomInput,
} from "reactstrap";
import EmpresaContext from "../../../../../contexts/Empresa";
import api from "../../../../../services/api";

const ConfiguracoesGerais: React.FC<any> = ({ history, ...props }) => {
  const [tabActive, setTabActive] = useState("geral");
  const notificationAlert = useRef<any>();
  const { empresaSelecionada } = useContext<any>(EmpresaContext);
  const { hasPermission, hasRole } = useContext(AuthContext);
  const [parametros, setParametros] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [valoresEditados, setValoresEditados] = useState<{ [id: number]: string }>({});
  const [salvando, setSalvando] = useState<{ [id: number]: boolean }>({});

  useEffect(() => {
    if (empresaSelecionada?.id) {
      buscarParametros();
    }
  }, [empresaSelecionada?.id]);

  async function buscarParametros() {
    setLoading(true);
    try {
      const { data } = await api.get("/common/parametros-empresas");
      setParametros(data);
      setValoresEditados({});
    } catch (error) {
      console.error("Erro ao buscar parâmetros:", error);
      notify("danger", "Houve um erro ao buscar os parâmetros.");
    } finally {
      setLoading(false);
    }
  }

  async function salvarParametro(param: any, novoValor: string) {
    setSalvando((prev) => ({ ...prev, [param.id]: true }));
    try {
      await api.put(`/common/parametros-empresas/${param.chave}`, { valor: novoValor });
      setParametros((prev) =>
        prev.map((p) => (p.id === param.id ? { ...p, valor: novoValor } : p))
      );
      setValoresEditados((prev) => {
        const next = { ...prev };
        delete next[param.id];
        return next;
      });
      notify("success", "Parâmetro atualizado com êxito.");
    } catch (error) {
      notify("danger", "Houve um erro ao atualizar o parâmetro.");
    } finally {
      setSalvando((prev) => ({ ...prev, [param.id]: false }));
    }
  }

  function handleToggle(param: any) {
    const valorAtual = param.valor === "true" || param.valor === true;
    const novoValor = (!valorAtual).toString();
    salvarParametro(param, novoValor);
  }

  function handleInputChange(id: number, valor: string) {
    setValoresEditados((prev) => ({ ...prev, [id]: valor }));
  }

  const notify = (type: any, msg: string) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text" style={{ zIndex: 100 }}>
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 3,
    };
    if (notificationAlert.current)
      notificationAlert.current.notificationAlert(options);
  };

  const CustomNavItem = ({ children, disabled, name }: any) => {
    return (
      <NavItem>
        <NavLink
          href="#"
          role="tab"
          className={classnames("mb-sm-3 mb-md-0 mt-2", {
            active: tabActive === name,
          })}
          onClick={() => setTabActive(name)}
          disabled={disabled}
        >
          {children}
        </NavLink>
      </NavItem>
    );
  };

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Configurações Gerais" parentName="Minha empresa" />
      <div className="w-100">
        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h1 className="mb-0">Configurações Gerais</h1>
          </CardHeader>
          <CardBody outline body>
            <Row>
              <Col xs={12} lg={12} md={12} sm={12}>
                <div className="nav-wrapper">
                  <Nav
                    className="nav-fill flex-column flex-md-row"
                    pills
                    role="tablist"
                  >
                    <CustomNavItem name="geral" disabled={!empresaSelecionada?.id}>
                      <>
                        <i className="fas fa-sliders-h mr-2"></i>
                        Geral
                      </>
                    </CustomNavItem>
                    
                  </Nav>
                </div>
                <hr className="m-0" />
                <div>
                  <TabContent activeTab={tabActive}>
                    <TabPane tabId="geral">
                      {tabActive === "geral" && empresaSelecionada?.id && (
                        <div className="p-4">
                          {loading ? (
                            <div className="text-center">
                              <Spinner color="primary" />
                            </div>
                          ) : parametros.length === 0 ? (
                            <p className="text-muted">Nenhum parâmetro configurável encontrado.</p>
                          ) : (
                            <div className="px-2">
                              {parametros.map((param, index) => {
                                const isBoolean = param.tipo === "boolean";
                                const valorBoolean = param.valor === "true" || param.valor === true;
                                const valorTexto =
                                  param.id in valoresEditados
                                    ? valoresEditados[param.id]
                                    : param.valor || "";
                                const foiEditado =
                                  param.id in valoresEditados &&
                                  valoresEditados[param.id] !== param.valor;

                                return (
                                  <div key={param.id}>
                                    <div className="d-flex align-items-center py-2 hover-bg-light rounded px-2" style={{ transition: "background 0.2s" }}>
                                      <div className="flex-grow-1 mr-3">
                                        <h6 className="mb-0 font-weight-bold">
                                          {param.descricao || param.chave}
                                        </h6>
                                        <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>
                                          {param.chave}
                                        </small>
                                        {isBoolean && (
                                          <small
                                            className={`d-block font-weight-bold ${valorBoolean ? "text-success" : "text-danger"}`}
                                            style={{ fontSize: "0.75rem" }}
                                          >
                                            {valorBoolean ? "true" : "false"}
                                          </small>
                                        )}
                                      </div>

                                      {isBoolean ? (
                                        <div>
                                          {salvando[param.id] ? (
                                            <Spinner size="sm" color="primary" />
                                          ) : (
                                            <CustomInput
                                              type="switch"
                                              id={`switch-${param.id}`}
                                              name={`switch-${param.id}`}
                                              label=""
                                              checked={valorBoolean}
                                              onChange={() => handleToggle(param)}
                                            />
                                          )}
                                        </div>
                                      ) : (
                                        <div className="d-flex align-items-center" style={{ minWidth: 280 }}>
                                          <Input
                                            type="text"
                                            value={valorTexto}
                                            onChange={(e) => handleInputChange(param.id, e.target.value)}
                                            bsSize="sm"
                                            className="mr-2"
                                          />
                                          {foiEditado && (
                                            <Button
                                              color="primary"
                                              size="sm"
                                              disabled={salvando[param.id]}
                                              onClick={() => salvarParametro(param, valoresEditados[param.id])}
                                            >
                                              {salvando[param.id] ? <Spinner size="sm" /> : "Salvar"}
                                            </Button>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    {index < parametros.length - 1 && <hr className="my-1 opacity-5" />}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      )}
                    </TabPane>
                  </TabContent>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default ConfiguracoesGerais;
